module.exports = __webpack_public_path__ + "static/media/modifyAndOrderAnother.a65e0d20.png";